/** 胸卡文字槽位默认与 CSS 计算（后台编辑、预览、小程序 canvas 共用逻辑） */

export const DEFAULT_NAME_SLOT = {
  xPct: 50,
  yPct: 42,
  fontSizePx: 52,
  color: '#111111',
  fontWeight: '700',
  lineHeight: 1.2,
  textAlign: 'center',
}

export const DEFAULT_IDENTITY_SLOT = {
  xPct: 50,
  yPct: 56,
  fontSizePx: 34,
  color: '#333333',
  fontWeight: '500',
  lineHeight: 1.25,
  textAlign: 'center',
}

export function defaultLayoutDraft() {
  return {
    name: { ...DEFAULT_NAME_SLOT },
    identity: { ...DEFAULT_IDENTITY_SLOT },
  }
}

export function normalizeSlot(raw, defaults) {
  const d = defaults || DEFAULT_NAME_SLOT
  const s = raw && typeof raw === 'object' ? raw : {}
  const align = String(s.textAlign || d.textAlign || 'center').toLowerCase()
  return {
    xPct: clamp(Number(s.xPct ?? d.xPct), 0, 100),
    yPct: clamp(Number(s.yPct ?? d.yPct), 0, 100),
    fontSizePx: clamp(Number(s.fontSizePx ?? d.fontSizePx), 12, 120),
    color: String(s.color || d.color || '#111111'),
    fontWeight: String(s.fontWeight || d.fontWeight || '600'),
    lineHeight: clamp(Number(s.lineHeight ?? d.lineHeight), 1, 2.5),
    textAlign: align === 'left' || align === 'right' ? align : 'center',
  }
}

export function parseLayoutJson(raw) {
  if (!raw || !String(raw).trim()) return defaultLayoutDraft()
  try {
    const o = JSON.parse(raw)
    return {
      name: normalizeSlot(o.name, DEFAULT_NAME_SLOT),
      identity: normalizeSlot(o.identity, DEFAULT_IDENTITY_SLOT),
    }
  } catch {
    return defaultLayoutDraft()
  }
}

export function slotToCss(slot) {
  const s = normalizeSlot(slot, DEFAULT_NAME_SLOT)
  let tx = '-50%'
  if (s.textAlign === 'left') tx = '0%'
  if (s.textAlign === 'right') tx = '-100%'
  return {
    left: `${s.xPct}%`,
    top: `${s.yPct}%`,
    transform: `translate(${tx}, -50%)`,
    fontSize: `${s.fontSizePx}px`,
    color: s.color,
    fontWeight: s.fontWeight,
    lineHeight: String(s.lineHeight),
    textAlign: s.textAlign,
  }
}

/** 与小程序 canvas / Word 导出一致的设计画布宽度（px） */
export const BADGE_DESIGN_WIDTH = {
  LANDSCAPE: 950,
  PORTRAIT: 600,
  SQUARE: 800,
}

/** 后台弹窗预览区域约等于的卡片宽度（px），用于按比例缩小字号 */
export const BADGE_PREVIEW_WIDTH = {
  LANDSCAPE: 520,
  PORTRAIT: 400,
  SQUARE: 440,
}

/** 弹窗预览用：字号按预览宽度 / 设计宽度缩放，避免字显得过大、叠在一起 */
export function slotToPreviewCss(slot, layoutType) {
  const css = slotToCss(slot)
  const layout = String(layoutType || 'LANDSCAPE').toUpperCase()
  const design = BADGE_DESIGN_WIDTH[layout] || BADGE_DESIGN_WIDTH.LANDSCAPE
  const preview = BADGE_PREVIEW_WIDTH[layout] || BADGE_PREVIEW_WIDTH.LANDSCAPE
  const ratio = preview / design
  const px = Math.round(parseFloat(String(css.fontSize || '0')) * ratio)
  return { ...css, fontSize: `${Math.max(12, px)}px` }
}

export function alignSlot(slot, h, v) {
  const s = { ...normalizeSlot(slot, DEFAULT_NAME_SLOT) }
  if (h === 'left') {
    s.xPct = 10
    s.textAlign = 'left'
  } else if (h === 'center') {
    s.xPct = 50
    s.textAlign = 'center'
  } else if (h === 'right') {
    s.xPct = 90
    s.textAlign = 'right'
  }
  if (v === 'top') s.yPct = 16
  else if (v === 'middle') s.yPct = 50
  else if (v === 'bottom') s.yPct = 84
  return s
}

function clamp(n, min, max) {
  if (!Number.isFinite(n)) return min
  return Math.min(max, Math.max(min, n))
}
